/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_RooftopInputs */

const en_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rooftop`)
};

const es_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azotea`)
};

const fr_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toit-terrasse`)
};

const de_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dachterrasse`)
};

const ja_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルーフトップ`)
};

const zh_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屋顶露台`)
};

const ar_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سطح (Rooftop)`)
};

const id_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atap Gedung`)
};

const it_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terrazza Panoramica / Rooftop`)
};

const ru_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На крыше`)
};

const pt_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura / Rooftop`)
};

const ko_val_rooftop = /** @type {(inputs: Val_RooftopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`루프탑`)
};

/**
* | output |
* | --- |
* | "Rooftop" |
*
* @param {Val_RooftopInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_rooftop = /** @type {((inputs?: Val_RooftopInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_RooftopInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_rooftop(inputs)
	if (locale === "es") return es_val_rooftop(inputs)
	if (locale === "fr") return fr_val_rooftop(inputs)
	if (locale === "de") return de_val_rooftop(inputs)
	if (locale === "ja") return ja_val_rooftop(inputs)
	if (locale === "zh") return zh_val_rooftop(inputs)
	if (locale === "ar") return ar_val_rooftop(inputs)
	if (locale === "id") return id_val_rooftop(inputs)
	if (locale === "it") return it_val_rooftop(inputs)
	if (locale === "ru") return ru_val_rooftop(inputs)
	if (locale === "pt") return pt_val_rooftop(inputs)
	return ko_val_rooftop(inputs)
});